export default require("./../../webpack/emoji-loader!./../../vendor/emojis/img-buildkite-64.json");
